import { FC, ReactNode } from 'react';

import classnames from 'classnames';

import { Icon } from '../../../icon/components/Icon/Icon';

const facetColors = [
   'bg-component-data-display-facet-background-color-segment-1 text-component-data-display-facet-icon-color-segment-1',
   'bg-component-data-display-facet-background-color-segment-2 text-component-data-display-facet-icon-color-segment-2',
   'bg-component-data-display-facet-background-color-segment-3 text-component-data-display-facet-icon-color-segment-3',
   'bg-component-data-display-facet-background-color-segment-4 text-component-data-display-facet-icon-color-segment-4',
   'bg-component-data-display-facet-background-color-neutral text-component-data-display-facet-icon-color-neutral'
];

interface Props {
   facetIcon?: string;
   facetColor?: number;
   trailingIcon?: string;
   onClick?: () => void;
   children?: ReactNode;
}

export const SearchItem: FC<Props> = ({ children, facetIcon, facetColor = 0, trailingIcon, onClick }) => (
   <button
      data-testid={`search-item${onClick ? '--clickable' : ''}`}
      type="button"
      onClick={onClick}
      className={classnames(
         'rounded-component-data-display-search-item-border-radius gap-component-data-display-search-item-container-spacing-gap pr-component-data-display-search-item-container-spacing-padding-x-without-facet bg-component-data-display-search-item-container-color-background-default-enabled flex size-full items-stretch justify-between overflow-hidden',
         !facetIcon ? 'pl-component-data-display-search-item-container-spacing-padding-x-without-facet' : 'pl-component-data-display-search-item-container-spacing-padding-left-with-facet',
         'hover:bg-component-data-display-search-item-container-color-background-default-hover active:bg-component-data-display-search-item-container-color-background-default-pressed focus-visible:bg-component-data-display-search-item-container-color-background-default-focused'
      )}
   >
      {facetIcon && (
         <div data-testid="search-item-facet" className={classnames('p-component-data-display-facet-container-spacing-padding-large flex items-center justify-center', facetColors[facetColor % Object.keys(facetColors).length])}>
            <Icon icon={facetIcon} color="inherit" size="body" />
         </div>
      )}
      <div className={classnames('gap-component-data-display-search-item-content-spacing-gap py-component-data-display-search-item-content-spacing-padding-y flex size-full flex-col')}>{children}</div>
      {trailingIcon && (
         <div data-testid="search-item-trailing-icon" className="text-component-data-display-search-item-icon-end-color-fill-enabled flex items-center">
            <Icon icon={trailingIcon} color="inherit" size="body" />
         </div>
      )}
   </button>
);
